import React from "react";
import { CarouselSlideTypeBadge } from "./CarouselSlideTypeBadge";
import { useYouTubeTitle } from "../hooks-functions/UseYoutubeTitle";

interface CarouselSlideVideoCardProps {
    index: number;
    videoUrl: string;
    isDragging: boolean;
    onEdit: () => void;
    onRemove: (i: number) => void;
    onDragStart: (idx: number, e: React.DragEvent) => void;
    onDragOver: (e: React.DragEvent) => void;
    onDrop: (idx: number, e: React.DragEvent) => void;
    onDragEnd: () => void;
    onTouchStart: (idx: number) => void;
    onTouchMove: (e: React.TouchEvent) => void;
    onTouchEnd: () => void;
}

function extractYouTubeId(url: string): string | null {
    const match = url.match(
        /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|shorts\/))([a-zA-Z0-9_-]{11})/
    );
    return match ? match[1] : null;
}

export function CarouselSlideVideoCard({
    index,
    videoUrl,
    onEdit,
    onRemove,
    isDragging,
    onDragStart,
    onDragOver,
    onDrop,
    onDragEnd,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
}: CarouselSlideVideoCardProps) {
    const videoId = extractYouTubeId(videoUrl);
    const title = useYouTubeTitle(videoUrl);
    
    return (
        <div
            className={`slideCard expanded ${isDragging ? "is-dragging" : ""}`}
            onDragOver={onDragOver}
            onDrop={(e) => onDrop(index, e)}
            onTouchStart={() => onTouchStart(index)}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            data-index={index}
        >
            <div className="slideCard__number">{index + 1}</div>
            <div className="slideCard__panel">
                <CarouselSlideTypeBadge type="video" />
                <button
                    className="slideCard__drag"
                    aria-label="reorder"
                    draggable
                    onDragStart={(e) => onDragStart(index, e)}
                    onDragEnd={onDragEnd}
                >
                    <span className="slideCard__dragIcon" />
                </button>
                <div className="slideCard__content">
                    <div className="slideCard__header">
                        <h4 className="slideCard__title">{title}</h4>
                    </div>
                    <div className="slideCard__media">
                        <div className="slideCard__desktop">
                            {videoId ? (
                                <a
                                    href={`https://www.youtube.com/watch?v=${videoId}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="slideCard__videoThumbnail"
                                >
                                    <img
                                        className="slideCard__image"
                                        src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                                        alt="Video preview"
                                    />
                                    <span className="slideCard__playBtn">&#9654;</span>
                                </a>
                            ) : (
                                <div className="logoPlaceholder">
                                    <span>No video URL</span>
                                </div>
                            )}
                            <div className="slideCard__caption">
                                <span>Video preview</span>
                            </div>
                        </div>
                    </div>
                    <div className="slideCard__actions">
                        <button className="slideCard__btn--edit" onClick={onEdit}>
                            <span className="slideCard__btnIcon slideCard__btnIcon--edit" />
                            <span className="slideCard__btnText">Edit</span>
                        </button>
                        <button className="slideCard__btn--delete" onClick={() => onRemove(index)}>
                            <span className="slideCard__btnIcon slideCard__btnIcon--delete" />
                            <span className="slideCard__btnText">Delete</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}